import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { CheckCircle } from "@mui/icons-material";
import { COLORS } from "../constants/constants";

interface MoreServiceProps {
  handleOpenBooking: (serviceId: string) => void;
}

const MoreService: React.FC<MoreServiceProps> = (props) => {
  const features = [
    "Tay nghề kỹ thuật cao",
    "Phục vụ nhanh – đúng giờ",
    "Giá cả minh bạch, rõ ràng",
    "Bảo hành rõ ràng, có cam kết",
    "Tư vấn tận tâm – chuyên nghiệp",
    "Trang thiết bị hiện đại – an toàn",
  ];
  return (
    <section id="more-services" className="bg-white">
      <Container className="flex flex-col lg:flex-row items-center w-full pb-[80px]">
        <div className="flex-1 relative w-full flex justify-center lg:justify-start">
          <div className="rounded-[2rem] border-t-[6px] border-l-[6px] border-primary_blue overflow-hidden w-[320px] h-auto z-10">
            <img
              src="/images/i1.png"
              alt="Thợ vệ sinh máy lạnh"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="absolute bottom-[-80px] left-[10px] lg:left-[130px] w-[265px] border-t-[6px] border-l-[6px] border-white rounded-2xl overflow-hidden shadow-lg z-20 hidden lg:block">
            <img
              src="/images/i2.png"
              alt="Thợ kỹ thuật"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="w-full lg:w-1/2 text-left pt-5">
          <Typography
            sx={{
              fontSize: {
                xs: "16px",
                lg: "34px",
              },
            }}
            className="pb-4  text-gray-600  !font-black"
          >
            Chào mừng đến với dịch vụ máy máy lạnh của chúng tôi
          </Typography>
          <Typography
            sx={{
              fontSize: {
                xs: "16px",
                lg: "24px",
              },
            }}
            className="pb-6  !font-thin text-gray-600"
          >
            Chúng tôi làm cho không gian của bạn mát lạnh! Công ty dịch vụ máy
            lạnh chuyên nghiệp và đáng tin cậy cung cấp các giải pháp hàng đầu
            cho gia đình và doanh nghiệp. Đảm bảo sự hài lòng!"
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
            {features.map((text, index) => (
              <div
                key={index}
                className="flex items-center space-x-2 bg-gray-50 px-3 py-2 rounded-md"
              >
                <CheckCircle className="text-primary_blue w-5 h-5 flex-shrink-0" />
                <span className="text-sm text-gray-800">{text}</span>
              </div>
            ))}
          </div>
          <Box className="flex gap-4 pt-10">
            <Button
              className=" !text-base !bg-primary_blue !text-white !px-4 !py-2"
              variant="contained"
              color="success"
              onClick={() => props.handleOpenBooking("")}
              sx={{
                color: "#4D4D4D",
                textTransform: "none",
                backgroundColor: COLORS.primary_blue,
                "&:hover": {
                  color: COLORS.primary_blue,
                },
              }}
            >
              Đặt lịch ngay
            </Button>
            <Button
              className=" !text-base !bg-transparent !px-4 !py-2"
              variant="contained"
              color="success"
              href="#services"
              sx={{
                color: "#4D4D4D",
                textTransform: "none",
                backgroundColor: COLORS.primary_blue,
                "&:hover": {
                  color: COLORS.primary_blue,
                },
              }}
            >
              Tìm hiểu thêm
            </Button>
          </Box>
        </div>
      </Container>
    </section>
  );
};

export default MoreService;
